import { DateTime } from "luxon";

export enum DeviceType {
  Fidelix = 0,
  Sigfox = 1,
  EDI = 2,
  Curves = 3,
  Datahub = 4,
}

export enum DeviceStatus {
  Idle = 0,
  Connected = 1,
  Disconnected = 2,
  AuthFailure = 3,
  VersionFailure = 4,
  Disabled = 5,
}

export class DeviceLite {
  id: number;
  name: string;
  type: DeviceType;
  levelId: number;
  companyId: number;
  ipAddress: string;
  port: string;
  loginPort: number;
  building: string;
  authKey?: string;
  externalId: string;
  enabled: boolean;
  isCalendarHidden: boolean;
  integrationId?: string | null;

  constructor(device: DeviceLite) {
    this.id = device.id;
    this.name = device.name;
    this.type = device.type;
    this.levelId = device.levelId;
    this.building = device.building;
    this.authKey = device.authKey;
    this.companyId = device.companyId;
    this.ipAddress = device.ipAddress;
    this.port = device.port;
    this.loginPort = device.loginPort;
    this.enabled = device.enabled;
    this.externalId = device.externalId;
    this.isCalendarHidden = device.isCalendarHidden;
    this.integrationId = device.integrationId;
  }
}

export class ExternalDevice extends DeviceLite {
  domainCode?: string;
  username?: string;
  password?: string;

  constructor(device: ExternalDevice) {
    super(device);
    if (device.type !== DeviceType.Fidelix) {
      this.domainCode = device.domainCode;
      this.username = device.username;
      this.password = device.password;
    }
  }
}

export type DeviceStateResponse = {
  id: number;
  status: DeviceStatus;
  version: string | null;
  lastOnlineAt: string | null;
};

export class DeviceState {
  id: number;
  status: DeviceStatus;
  version: string | null;
  lastOnlineAt: DateTime | null;
  constructor(data: {
    id: number;
    status: DeviceStatus;
    version: string | null;
    lastOnlineAt: string | null;
  }) {
    this.id = data.id;
    this.status = data.status;
    this.version = data.version;
    this.lastOnlineAt = data.lastOnlineAt
      ? DateTime.fromISO(data.lastOnlineAt)
      : null;
  }
}

export type DeviceResponse = {
  id: number;
  name: string;
  levelId: number;
  type: DeviceType;
  companyId: number;
  ipAddress: string;
  port: string;
  loginPort: number;
  building: string;
  externalId: string;
  enabled: boolean;
  isCalendarHidden: boolean;
  status: DeviceStatus;
  version: string | null;
  lastOnlineAt: string | null;
  graphicsId?: number;
  integrationId?: string | null;
};

export class Device extends DeviceLite {
  status: DeviceStatus;
  version: string | null;
  lastOnlineAt: DateTime | null;
  constructor(device: DeviceResponse) {
    super(device);
    this.status = device.status;
    this.version = device.version;
    this.lastOnlineAt = device.lastOnlineAt
      ? DateTime.fromISO(device.lastOnlineAt)
      : null;
  }
}
